import { render, staticRenderFns } from "./CmgRewardsPromoBanner.vue?vue&type=template&id=9daf0a08&scoped=true&lang=pug&"
import script from "./cmg-rewards-promo-banner.ts?vue&type=script&lang=ts&"
export * from "./cmg-rewards-promo-banner.ts?vue&type=script&lang=ts&"
import style0 from "./CmgRewardsPromoBanner.vue?vue&type=style&index=0&id=9daf0a08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9daf0a08",
  null
  
)

export default component.exports